import { mountComponentWithDataProps } from 'javascripts/shared/utils/react_mount';

import { AudiobookApp } from 'javascripts/apps/audiobook_app';

$(() => {
  mountComponentWithDataProps('#audiobook-app', AudiobookApp);
});
